/* DelaFuente — Letter Picker (casual initial ring).
 * Renders an A–Z initial selector, injects line-item property "Initial" into the /cart/add form,
 * and gates the add-to-cart button (main + sticky) until an initial is chosen. Vanilla, no deps.
 */
(function () {
  var cfgEl = document.getElementById('dlf-lp-config');
  if (!cfgEl) return;
  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  var PROP = CFG.propName || 'Initial';
  var LETTERS = (CFG.letters || 'ABCDEFGHIJKLMNOPQRSTUVWXYZ').split('');
  var REQUIRED = CFG.required !== false;
  var ES = String(CFG.lang || '').slice(0, 2).toLowerCase() === 'es';
  var L = ES ? {
    heading: 'Elige tu inicial', initial: 'Inicial', helpLater: 'Ayúdame después',
    sizingLater: 'Confirmar tras la entrega — kit de medición gratis incluido',
    sizingNote: 'Con tu anillo llega un kit de medición gratis — confirma tu talla cuando llegue. Compra hoy.'
  } : {
    heading: 'Choose your initial', initial: 'Initial', helpLater: 'Help me later',
    sizingLater: 'Confirm after delivery — free sizing kit included',
    sizingNote: 'A free sizing kit ships with your ring — confirm your size once it arrives. Check out today.'
  };
  var chosen = null;

  function form() {
    return document.querySelector('form[action*="/cart/add"]');
  }
  function mainBtn() {
    var f = form();
    return f && f.querySelector('button[type="submit"]');
  }

  // --- line-item property input -------------------------------------------------
  function setProp(val) {
    var f = form();
    if (!f) return;
    var el = f.querySelector('input[data-dlf-lp]');
    if (val == null) { if (el) el.remove(); return; }
    if (!el) {
      el = document.createElement('input');
      el.type = 'hidden';
      el.setAttribute('data-dlf-lp', '');
      el.name = 'properties[' + PROP + ']';
      f.appendChild(el);
    }
    el.value = val;
  }

  // --- add-to-cart gating (coexists with the ring-size gate in the section) ------
  function refreshGate() {
    var btn = mainBtn();
    if (!btn) return;
    if (REQUIRED && !chosen) {
      btn.setAttribute('data-letter-required', '');
      btn.disabled = true;
    } else {
      btn.removeAttribute('data-letter-required');
      // Only re-enable if no other gate (ring size / no-preselect / out of stock) is holding it.
      if (!btn.hasAttribute('data-size-required') && !btn.hasAttribute('data-oos') && !btn.hasAttribute('data-nps-required')) {
        btn.disabled = false;
      }
    }
  }

  // --- UI ----------------------------------------------------------------------
  var root;
  function buildUI() {
    if (document.querySelector('.dlf-lp')) return true;
    var f = form();
    if (!f) return false;

    root = document.createElement('div');
    root.className = 'dlf-lp';

    var label = document.createElement('div');
    label.className = 'dlf-lp__label';
    label.textContent = (ES ? L.heading : (CFG.heading || L.heading));

    var grid = document.createElement('div');
    grid.className = 'dlf-lp__grid';
    grid.setAttribute('role', 'group');
    grid.setAttribute('aria-label', (ES ? L.heading : (CFG.heading || L.heading)));

    LETTERS.forEach(function (ltr) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'dlf-lp__btn';
      b.textContent = ltr;
      b.setAttribute('aria-pressed', 'false');
      b.setAttribute('aria-label', L.initial + ' ' + ltr);
      b.addEventListener('click', function () { select(ltr); });
      grid.appendChild(b);
    });

    root.appendChild(label);
    root.appendChild(grid);

    // Insert just above the buy buttons (fallback: top of the form).
    var btn = mainBtn();
    var anchor = btn && (btn.closest('buy-buttons-component, .buy-buttons, [class*="buy-buttons"], .product-form__buttons') || btn.closest('form'));
    if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(root, anchor);
    else f.insertBefore(root, f.firstChild);

    return true;
  }

  function select(ltr) {
    chosen = ltr;
    setProp(ltr);
    if (root) {
      root.removeAttribute('data-flash');
      root.querySelectorAll('.dlf-lp__btn').forEach(function (b) {
        b.setAttribute('aria-pressed', String(b.textContent === ltr));
      });
    }
    refreshGate();
  }

  function flash() {
    if (!root) return;
    root.setAttribute('data-flash', 'true');
    root.scrollIntoView({ behavior: 'smooth', block: 'center' });
    setTimeout(function () { root.removeAttribute('data-flash'); }, 1000);
  }

  // --- ring size "Help me later" (ported from the diamond picker to match The Arco exactly) ------
  var helpLater = false;
  function sizeControl() { return document.querySelector('select[name="options[Ring size]"]'); }
  // When deferring, pick a sensible default (closest to 7) so a variant still resolves.
  function ensureDefaultSize() {
    var sel = sizeControl(); if (!sel || sel.value) return;
    var opts = Array.prototype.slice.call(sel.options).filter(function (o) { return o.value; });
    if (!opts.length) return;
    var best = opts[0], bd = Infinity;
    opts.forEach(function (o) { var n = parseFloat(o.value); var d = isNaN(n) ? Infinity : Math.abs(n - 7); if (d < bd) { bd = d; best = o; } });
    sel.value = best.value; sel.dispatchEvent(new Event('change', { bubbles: true }));
  }
  var SIZING_LATER = L.sizingLater;
  function syncSizeProp() {
    var f = form(); if (!f) return;
    var el = f.querySelector('input[data-dlf-sizing]');
    if (helpLater) {
      if (!el) { el = document.createElement('input'); el.type = 'hidden'; el.setAttribute('data-dlf-sizing', ''); el.name = 'properties[Sizing]'; f.appendChild(el); }
      el.value = SIZING_LATER;
    } else if (el) { el.remove(); }
  }
  var SIZING_NOTE = L.sizingNote;
  function swapSizeGuide() {
    var swapped = document.querySelector('.dlf-sizeguide-swapped');
    var a = document.querySelector('a[href*="ring-size-guide"]');
    var line = swapped || (a ? (a.closest('p') || a.parentElement) : null);
    if (!line) return;
    if (helpLater) {
      if (!line.classList.contains('dlf-sizeguide-swapped')) { line.setAttribute('data-dlf-orig', line.innerHTML); line.classList.add('dlf-sizeguide-swapped'); }
      if (line.textContent.trim() !== SIZING_NOTE) line.textContent = SIZING_NOTE;
    } else if (line.classList.contains('dlf-sizeguide-swapped')) {
      var orig = line.getAttribute('data-dlf-orig');
      if (orig != null) line.innerHTML = orig;
      line.classList.remove('dlf-sizeguide-swapped'); line.removeAttribute('data-dlf-orig');
    }
  }
  // "Help me later" link overlaid on the right of the ring-size dropdown (theme rebuilds the
  // .variant-option on variant change, so re-establish on each render).
  function renderSizeHelp() {
    var sel = sizeControl(); if (!sel) return;
    var wrap = sel.closest('.variant-option__select-wrapper'); if (!wrap) return;
    wrap.classList.add('dlf-hml-host');
    var btn = wrap.querySelector('.dlf-hml-btn');
    if (!btn) { btn = document.createElement('button'); btn.type = 'button'; btn.className = 'dlf-hml-btn'; wrap.appendChild(btn); }
    btn.textContent = (helpLater ? '✓ ' : '') + L.helpLater;
    btn.classList.toggle('is-on', helpLater);
    wrap.classList.toggle('dlf-size-dim-on', helpLater);
    swapSizeGuide();
    syncSizeProp();
  }
  var _sizingWired = false;
  function setupSizing() {
    renderSizeHelp();
    if (_sizingWired) return;
    _sizingWired = true;
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('.dlf-hml-btn');
      if (b) { e.preventDefault(); e.stopPropagation(); helpLater = !helpLater; if (helpLater) ensureDefaultSize(); renderSizeHelp(); }
    }, true);
    document.addEventListener('variant:update', function () { renderSizeHelp(); });
  }

  function setup() {
    if (!buildUI()) return false;
    setProp(null);
    refreshGate();
    setupSizing();

    // Keep the gate honest if the size script (or Heritage) re-enables the button.
    var btn = mainBtn();
    if (btn && !btn.__dlfLpObs) {
      var obs = new MutationObserver(function () {
        if (REQUIRED && !chosen && !btn.disabled) { btn.disabled = true; btn.setAttribute('data-letter-required', ''); }
      });
      obs.observe(btn, { attributes: true, attributeFilter: ['disabled'] });
      btn.__dlfLpObs = obs;
    }

    // Guard the sticky add-to-cart button too (it's a separate custom-element button).
    var sticky = document.querySelector('.sticky-add-to-cart__button');
    if (sticky && !sticky.__dlfLpGuard) {
      sticky.addEventListener('click', function (e) {
        if (REQUIRED && !chosen) {
          e.preventDefault();
          e.stopImmediatePropagation();
          flash();
        }
      }, true);
      sticky.__dlfLpGuard = true;
    }
    return true;
  }

  // Try synchronously first (the script loads after the variant markup), so the letter
  // grid exists before the first paint — no flash.
  var tries = 0;
  if (!setup()) {
    var iv = setInterval(function () {
      if (setup() || ++tries > 25) clearInterval(iv);
    }, 250);
  }
})();
